import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcDiscover,
} from "react-icons/fa";
import { Col, Row } from "reactstrap";
import { MdCreditCard } from "react-icons/md";
import { NavLink } from "react-router-dom";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import store from "../../../redux/store";
import FetchServerData from "../../../provider/FetchServerData";
import Utils from "../../../provider/Utils";
// import AddressWithTimezone from "../address/AddressWithTimezone";
import PtsAlert from "../ptsAlert/PtsAlert";
import SaveButton from "../buttons/SaveButton";
import CancelIconButton from "../buttons/CancelIconButton";
import MaterialTable, { MTableBodyRow } from "material-table";
import "./Billing.css";
import {
  deleteAccount_Url,
  GetBilling_Url,
  UpdateBilling_Url,
} from "../../../provider/ServiceUrl";
import UiUtils from "../../../provider/UiUtils";
import DeleteIconButton from "../buttons/DeleteIconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import PurchasePlan from "./PurchasePlan";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import InputAdornment from "@material-ui/core/InputAdornment";
import SaveIcon from "@material-ui/icons/Save";
import TextField from "@material-ui/core/TextField";
import BillingReceipt from "./BillingReceipt";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import DeleteButton from "../buttons/DeleteButton";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PtsButton from "../buttons/PtsButton";
import StripeLogo from "../../../assets/img/StripeLogo.png";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);

const styles = {
  form: {
    maxWidth: "500px",
    margin: "2rem auto",
    padding: "24px",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    backgroundColor: "#fff",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
  },

  field: {
    marginBottom: "16px",
  },
  label: {
    display: "block",
    marginBottom: "2px",
    marginLeft: "2px",
    fontWeight: "600",
    color: "#4a5568",
    textAlign: "left",
  },
  input: {
    width: "100%",
    padding: "10px",
    border: "1px solid #cbd5e0",
    borderRadius: "6px",
    fontSize: "14px",
    boxSizing: "border-box",
  },
  inputBox: {
    border: "1px solid #cbd5e0",
    padding: "10px",
    borderRadius: "6px",
    backgroundColor: "#f7fafc",
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "16px",
  },

  error: {
    color: "#e53e3e",
    marginTop: "12px",
  },
  success: {
    color: "#38a169",
    marginTop: "12px",
  },
};
class Billing extends Component {
  billingAddressRef = React.createRef();
  header = store.getState().header.header;
  planType = store.getState().appUserData.appUserData.planType?.type;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  constructor(props) {
    super(props);
    let action = props.action;
    let openAddCreditCard = false;
    if (props.state) {
      openAddCreditCard = props.state.openAddCreditCard;
    }
    this.state = {
      action: action,
      initialPage: 0,
      pageSize: 20,
      clientId:
        "Ad-zNZr01ztw2yKSZWCGQVthVdXhI2hem142rF6lBTzjRt3hzLEbPG_Hzd8YnZrOyS1i86qnbOEATCrk",
      cardType: "",
      cardName: "",
      firstName: "",
      lastName: "",
      cardId: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cvvCode: "",
      planId: "",
      planName: "",
      planDescription: "",
      planPrice: "",
      planCurrency: "",
      subscriptionId: "",
      receipt: null,
      billingAddress: {},
      customerPaymentList: [],
      overagePaymentList: [],
      planList: [],
      subscriptions: [],
      creditCardList: [],
      keyboardArrow: false,
      isUpgradePlan: false,
      isPaging: false,
      open: false,
      isReceiptOpen: false,
      authorizedCaregiver: false,
      openAddCreditCard: openAddCreditCard,
      processing: false,
      render: false,
      rowsPerPage: 10,
      currentPage: 1,
      error: null,
      isDefault: false,
      isOverageFeeAgreement: false,
    };
    this.getBillingDetails();
  }

  componentDidMount() {
    let scrollTo = "";
    if (this.props.state) {
      scrollTo = this.props.state.scrollTo;
    }
    if (scrollTo === "savedCreditCards") {
      setTimeout(() => {
        const section = document.getElementById("savedCreditCardsSection");
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);
    }
  }

  getBillingDetails() {
    const postObject = {
      header: this.header,
    };
    FetchServerData.callPostService(GetBilling_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let creditCardList = output.data.creditCardList;
          let businessUseCase = output.data.businessUseCase;
          let customerPaymentList = output.data.customerPaymentList;
          let overagePaymentList = output.data.overagePaymentList;
          let subscriptions = output.data.subscriptions;
          let smsCredits = output.data.smsCredits;
          let isPaging = false;
          if (customerPaymentList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < customerPaymentList.length; i++) {
            customerPaymentList[i].cycleStartDate = Utils.getUtcToLocal(
              customerPaymentList[i].cycleStartDate
            );
            customerPaymentList[i].cycleEndDate = Utils.getUtcToLocal(
              customerPaymentList[i].cycleEndDate
            );
            customerPaymentList[i].orderDate = Utils.getUtcToLocal(
              customerPaymentList[i].orderDate
            );
          }

          for (let i = 0; i < overagePaymentList.length; i++) {
            overagePaymentList[i].cycleStartDate = Utils.getUtcToLocal(
              overagePaymentList[i].cycleStartDate
            );
            overagePaymentList[i].cycleEndDate = Utils.getUtcToLocal(
              overagePaymentList[i].cycleEndDate
            );
            overagePaymentList[i].orderDate = Utils.getUtcToLocal(
              overagePaymentList[i].orderDate
            );
          }

          for (let i = 0; i < creditCardList.length; i++) {
            creditCardList[i].address = Utils.getAddressAsText(
              creditCardList[i].billingAddress
            );
          }

          for (let i = 0; i < subscriptions.length; i++) {
            subscriptions[i].subscriptionStartdate = Utils.getUtcToLocal(
              subscriptions[i].subscriptionStartdate
            );
            subscriptions[i].subscriptionEnddate = Utils.getUtcToLocal(
              subscriptions[i].subscriptionEnddate
            );
            subscriptions[i].orderDate = Utils.getUtcToLocal(
              subscriptions[i].orderDate
            );
            subscriptions[i].nextBillingDate = Utils.getUtcToLocal(
              subscriptions[i].nextBillingDate
            );
          }
          if (smsCredits !== null) {
            store.dispatch(AppUserDataAction.setUsage(smsCredits));
          }
          this.setState({
            render: true,
            action: "view",
            open: false,
            isPaging: isPaging,
            creditCardList: creditCardList,
            customerPaymentList: customerPaymentList,
            overagePaymentList: overagePaymentList,
            businessUseCase: businessUseCase,
            subscriptions: subscriptions,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  getReceiptDetails(rowData) {
    const postObject = {
      header: this.header,
      payment: { id: rowData.id },
    };
    FetchServerData.callPostService("/billingms/getReceiptData", postObject)
      .then((output) => {
        let receiptDetails = output.data.receipt;
        if (output.status === "SUCCESS") {
          this.setState({
            render: true,
            isReceiptOpen: true,
            receipt: receiptDetails,
            action: "view",
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  editBillingDetails() {
    this.setState({
      action: "edit",
    });
  }

  editCancel() {
    this.setState({
      action: "view",
      cardId: "",
      firstName: "",
      lastName: "",
      cardType: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cvvCode: "",
      billingAddress: {},
    });
  }

  handleBillingAddressChange(address) {
    this.setState({ billingAddress: address });
  }

  handleCardTypeChange(e) {
    const { value } = e.target;
    this.setState({ cardType: value });
  }
  handleCardNumberChange(e) {
    this.setState({ cardNumber: e.target.value });
  }
  handleCardNameChange(e) {
    this.setState({ cardName: e.target.value });
  }
  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }

  handleExpiryDateChange(e) {
    let date = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    let month = "";
    let year = "";
    if (date.length > 6) date = date.slice(0, 6); // Limit to 6 digits

    // Format as MM/YYYY
    if (date.length >= 3) {
      date = `${date.slice(0, 2)}/${date.slice(2)}`;
      month = date.slice(0, 2);
      year = date.slice(3);
    }

    this.setState({
      expiryDate: date,
      cardMonth: month,
      cardYear: year,
    });
  }

  handlePayPalChange(e) {
    this.setState({ payPal: e.target.value });
  }
  handleCardMonthChange(date) {
    let newDate = moment(date).format("MM");
    this.setState({ cardMonth: newDate });
  }
  handleCardYearChange(date) {
    let newDate = moment(date).format("yyyy");
    this.setState({ cardYear: newDate });
  }
  handleCvvCodeChange(e) {
    this.setState({ cvvCode: e.target.value });
  }

  updateBillingToBackend() {
    const postObject = {
      header: this.header,
      cardDetails: {
        id: this.state.id,
        name: this.state.cardOwnerName,
        type: this.state.cardType,
        number: this.state.cardNumber,
        address: {
          id: this.billingAddressRef.current.state.id,
          line: this.billingAddressRef.current.state.line,
          state: {
            name: this.billingAddressRef.current.state.state.name,
            code: this.billingAddressRef.current.state.state.code,
            id: this.billingAddressRef.current.state.state.id,
            country: this.billingAddressRef.current.state.country,
          },
          city: this.billingAddressRef.current.state.city,
          zipcode: this.billingAddressRef.current.state.zipCode,
        },
      },
      // paypalDetails: {
      //   paypalid: this.state.payPal,
      // },
      planDetails: {
        id: this.state.planId,
      },
    };
    FetchServerData.callPostService(UpdateBilling_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let cardDetails = output.data.cardDetails;
          // let paypalDetails = output.data.paypalDetails;
          let planDetails = output.data.planDetails;
          this.setState({
            render: true,
            action: "view",
            id: cardDetails.id,
            cardType: cardDetails.type,
            cardOwnerName: cardDetails.name,
            cardNumber: cardDetails.number,
            billingAddress: cardDetails.address,
            // payPal: paypalDetails?.paypalid,
            // planId: paypalDetails?.id,
            planDescription: planDetails?.description,
            planName: planDetails?.name,
            planPrice: planDetails?.price,
            planCurrency: planDetails?.currency,
          });
        } else {
        }
      }
    );
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  async getPaypalConfigInfo(data) {
    const postObject = {
      header: this.header,
      customerOrder: {
        id: data?.id,
      },
    };

    await FetchServerData.callPostService("/paypalms/getInfo", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let paypalConfigVo = output.data.paypalConfigVo;
          this.setState({
            clientId: paypalConfigVo.clientId,
          });
        } else {
        }
      }
    );
  }

  deleteCoustomerOrder(data) {
    const postObject = {
      header: this.header,
      customerOrder: {
        id: data?.id,
      },
    };

    FetchServerData.callPostService("/customerOrderms/delete", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getBillingDetails();
          // let paypalOrder = output.data.customerOrderPayment;
          // return paypalOrder.order_id;
        } else {
        }
      }
    );
  }

  showActionButton(data) {
    return (
      <>
        {data?.status !== "Completed" && (
          <>
            <DeleteIconButton
              domainObject={data.name}
              onClick={this.deleteCoustomerOrder.bind(this, data)}
            />
          </>
        )}
      </>
    );
  }

  // customerOrderpurchasePlan(plan) {
  //   const postObject1 = {
  //     header: this.header,
  //     plan: {
  //       id: plan?.id,
  //     },
  //   };
  //   FetchServerData.callPostService(
  //     "/customerOrderms/purchasePlan",
  //     postObject1
  //   ).then((output) => {
  //     if (output.status === "SUCCESS") {
  //       // PtsAlert.success(output.message);
  //       let paypalPayment = output.data.customerOrderPayment?.paypalPayment;
  //       window.open(
  //         paypalPayment.checkoutUrl,
  //         "paypal",
  //         "width=600,height=500,screenX=500,screenY=80"
  //       );
  //       this.getBillingDetails();
  //       this.setState({
  //         render: true,
  //         open: false,
  //         // planList: planList,
  //       });
  //     } else {
  //     }
  //   });
  // }
  customerOrderpurchasePlan(plan) {
    // this.props.navigate("/purchaseEventPlan", {
    //   state: {
    //     action: "view",
    //     eventId: this.state.eventId,
    //     eventPlanId: plan?.id,
    //   },
    // });
    if (this.state.isUpgradePlan) {
      this.setState({
        action: "PurchasePlan",
        pageId: "UpgradePlan",
        planId: plan.id,
      });
    } else
      this.setState({
        action: "PurchasePlan",
        pageId: "SubscriptionsPlan",
        planId: plan.id,
        subscriptionId: "",
      });
  }

  getPlanListForUseCase() {
    const postObject1 = {
      header: this.header,
      businessUseCase: {
        id: this.state.businessUseCase?.id,
      },
    };
    FetchServerData.callPostService(
      "/planms/getForBusinessUseCase",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let planList = output.data.planList;
        this.setState({
          render: true,
          open: true,
          planList: planList,
          isUpgradePlan: false,
        });
      } else {
      }
    });
  }

  upgradePlanListForUseCase(data) {
    const postObject1 = {
      header: this.header,
      businessUseCase: {
        id: this.state.businessUseCase?.id,
      },
    };
    FetchServerData.callPostService(
      "/planms/getForBusinessUseCase",
      postObject1
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let planList = output.data.planList;
        const upgradePlanList = planList.filter(
          (item) => item.price > data?.price
        );
        this.setState({
          render: true,
          open: true,
          planList: upgradePlanList,
          isUpgradePlan: true,
          subscriptionId: data.id,
        });
      } else {
      }
    });
  }

  handleOpen() {
    this.getPlanListForUseCase();
    this.setState({
      open: true,
    });
  }
  handleClose() {
    this.setState({
      open: false,
    });
  }
  handleReceiptClose() {
    this.setState({
      isReceiptOpen: false,
    });
  }

  handleAddCreditCardOpen() {
    this.setState({
      openAddCreditCard: true,
    });
  }
  handleAddCreditCardClose() {
    this.setState({
      openAddCreditCard: false,
    });
  }
  createCreditCardToBackend() {
    const postObject = {
      header: this.header,
      cardDetails: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        type: this.state.cardType,
        number: this.state.cardNumber,
        month: this.state.cardMonth,
        year: this.state.cardYear,
        cvv: this.state.cvvCode,
        billingAddress: {
          line: this.billingAddressRef.current.state.line,
          state: {
            name: this.billingAddressRef.current.state.state.name,
            code: this.billingAddressRef.current.state.state.code,
            id: this.billingAddressRef.current.state.state.id,
            country: this.billingAddressRef.current.state.country,
          },
          city: this.billingAddressRef.current.state.city,
          zipcode: this.billingAddressRef.current.state.zipCode,
        },
      },
    };
    FetchServerData.callPostService("/billingms/addCard", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let creditCardList = output.data.creditCardList;
          this.setState({
            render: true,
            action: "view",
            creditCardList: creditCardList,
            cardId: "",
            firstName: "",
            lastName: "",
            cardType: "",
            cardNumber: "",
            cardMonth: "",
            cardYear: "",
            cvvCode: "",
            billingAddress: {},
          });
        } else {
        }
      }
    );
  }
  updateCreditCardToBackend() {
    const postObject = {
      header: this.header,
      cardDetails: {
        id: this.state.cardId,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        type: this.state.cardType,
        number: this.state.cardNumber,
        month: this.state.cardMonth,
        year: this.state.cardYear,
        cvv: this.state.cvvCode,
        // billingAddress: {
        //   id: this.billingAddressRef.current.state.id,
        //   line: this.billingAddressRef.current.state.line,
        //   state: {
        //     name: this.billingAddressRef.current.state.state.name,
        //     code: this.billingAddressRef.current.state.state.code,
        //     id: this.billingAddressRef.current.state.state.id,
        //     country: this.billingAddressRef.current.state.country,
        //   },
        //   city: this.billingAddressRef.current.state.city,
        //   zipcode: this.billingAddressRef.current.state.zipCode,
        // },
      },
    };
    FetchServerData.callPostService("/billingms/updateCard", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let creditCardList = output.data.creditCardList;
          this.setState({
            render: true,
            action: "view",
            creditCardList: creditCardList,
            cardId: "",
            firstName: "",
            lastName: "",
            cardType: "",
            cardNumber: "",
            cardMonth: "",
            cardYear: "",
            cvvCode: "",
            billingAddress: {},
          });
        } else {
        }
      }
    );
  }

  toEditCreditCardDetails(rowData) {
    this.setState({
      action: "editCreditCard",
      cardId: rowData.id,
      firstName: rowData.firstName,
      lastName: rowData.lastName,
      cardType: rowData.type,
      cardNumber: rowData.number,
      cardMonth: rowData.month?.toString().padStart(2, "0"),
      cardYear: rowData.year?.toString(),
      expiryDate: `${rowData.month
        ?.toString()
        .padStart(2, "0")}/${rowData.year?.toString()}`,
      cvvCode: "",
      billingAddress: rowData.billingAddress,
    });
  }

  deleteCraditCardInBackend(data) {
    const postObject = {
      header: this.header,
      cardDetails: {
        id: data?.id,
      },
    };

    FetchServerData.callPostService("/billingms/deleteCard", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let creditCardList = output.data.creditCardList;
          this.setState({
            render: true,
            action: "view",
            creditCardList: creditCardList,
          });
        } else {
        }
      }
    );
  }
  getIcon = () => {
    switch (this.state.cardType) {
      case "visa":
        return <FaCcVisa size={32} color="#1a1f71" />;
      case "master card":
        return <FaCcMastercard size={32} color="#eb001b" />;
      case "american express":
        return <FaCcAmex size={32} color="#2e77bb" />;
      case "discover":
        return <FaCcDiscover size={32} color="#f76f02" />;
      default:
        return <MdCreditCard size={32} color="#aaa" />;
    }
  };

  handleKeyboardArrow() {
    this.setState({
      keyboardArrow: !this.state.keyboardArrow,
    });
  }

  renderTableRows = (rowData) => {
    const { rowsPerPage, currentPage } = this.state;
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return rowData.paymentList
      .slice(startIndex, endIndex)
      .map((value, index) => (
        <tr key={index}>
          <td>{value.subscriptionType}</td>
          <td>{`${value.currencySymbol}${Utils.formatWithCommas(
            value.paidAmount
          )}`}</td>
          {/* <td>{Utils.getUtcToLocal(value.orderDate)}</td> */}
          <td>{Utils.getUtcToLocal(value.cycleStartDate)}</td>
          <td>{Utils.getUtcToLocal(value.cycleEndDate)}</td>
          <td>{value.transactionId}</td>
          <td>{value.paymentStatus}</td>
        </tr>
      ));
  };

  renderPagination = (rowData) => {
    const { rowsPerPage, currentPage } = this.state;
    const totalPages = Math.ceil(rowData.paymentList.length / rowsPerPage);

    return (
      <>
        <div className="d-flex justify-content-between align-items-end">
          <div className="col-sm-2 pe-2">
            <select
              className="form-select d-inline-block w-auto ms-2 cursor-pointer"
              value={this.state.rowsPerPage}
              onChange={this.handleRowsPerPageChange}
            >
              {[5, 10, 20, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-10">
            <nav className="ms-4">
              <ul className="pagination justify-content-end">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                  onClick={() =>
                    this.setState({ currentPage: Math.max(1, currentPage - 1) })
                  }
                >
                  <button className="page-link">Previous</button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i + 1}
                    className={`page-item ${i + 1 === currentPage ? "active" : ""
                      }`}
                    onClick={() => this.setState({ currentPage: i + 1 })}
                  >
                    <button className="page-link">{i + 1}</button>
                  </li>
                ))}
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                  onClick={() =>
                    this.setState({
                      currentPage: Math.min(totalPages, currentPage + 1),
                    })
                  }
                >
                  <button className="page-link">Next</button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </>
    );
  };

  handleRowsPerPageChange = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      currentPage: 1,
    });
  };

  handleAuthorizedClose = () => {
    this.setState({ authorizedCaregiver: !this.state.authorizedCaregiver });
  };
  handleOpenAuthorized = () => {
    this.setState({ authorizedCaregiver: true });
  };

  toDeleteAuthorizedConfirmationWindow = () => {
    this.setState({ confirmWindowOpen: true, authorizedCaregiver: false });
  };

  handleConfirmWindowClose = () => {
    this.setState({ confirmWindowOpen: !this.state.confirmWindowOpen });
  };

  handlePasswordChange(e) {
    this.setState({ accountPassword: e.target.value });
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  deleteProfileInBackend() {
    const postObject = {
      header: this.header,
      credential: this.state.accountPassword,
    };
    FetchServerData.callPostService(deleteAccount_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.props.navigate("/");
        } else {
        }
      }
    );
  }

  toReceiptDetails(e, data) {
    if (e.target.closest(".action-button")) return;
    if (
      this.billingReceiptDialogueRef &&
      this.billingReceiptDialogueRef.current
    ) {
      this.billingReceiptDialogueRef.current.showReceiptDetails(data);
    }
  }

  handleSort(column) {
    const { sortColumn, sortDirection, smsContactList } = this.state;
    let newDirection = "asc";

    if (sortColumn === column && sortDirection === "asc") {
      newDirection = "desc";
    }

    this.setState({
      smsContactList: Utils.sortList(smsContactList, column, newDirection),
      sortColumn: column,
      sortDirection: newDirection,
    });
  }

  deleteCreditCardToBackend(data) {
    const postObject = {
      header: this.header,
      card: {
        id: data.id,
      },
    };

    FetchServerData.callPostService("/paymentms/removeCard", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          const updatedList = this.state.creditCardList.filter(
            (card) => card.id !== data.id
          );

          this.setState({
            creditCardList: updatedList,
            render: true,
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  setDefaultCardToBackend(data) {
    const postObject = {
      header: this.header,
      card: {
        id: data.id,
      },
    };

    FetchServerData.callPostService("/paymentms/setDefaultCard", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          this.getBillingDetails();
        } else {
        }
      })
      .catch((error) => { });
  }

  addNewCreditCard = async (e, stripe, elements) => {
    e.preventDefault();
    this.setState({ processing: true, error: null });

    if (!stripe || !elements) {
      this.setState({
        error: "Stripe.js has not loaded yet.",
        processing: false,
      });
      return;
    }

    // Step 1
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: { name: this.state.cardName },
    });

    if (error) {
      this.setState({
        error: error.message,
        processing: false,
      });
      return;
    } else {
      // Step 2  Backend call to create client secret
      const postObject = {
        header: this.header,
        paymentMethodId: paymentMethod.id,
        isDefault: this.state.isDefault,
      };
      const resp = await FetchServerData.callPostService(
        "/paymentms/addCard",
        postObject
      );
      if (resp.status === "SUCCESS") {
        this.getBillingDetails();
        if (this.state.openAddCreditCard) {
          store.dispatch(AppUserDataAction.setCardExpired(false));
        }
        this.setState({ openAddCreditCard: false, cardName: "" });
      } else {
      }
    }
  };

  handleIDefaultChange(e) {
    this.setState({
      isDefault: e.target.checked,
    });
  }
  handleIsOverageFeeAgreementChange(e) {
    this.setState({
      isOverageFeeAgreement: e.target.checked,
    });
  }

  goToInvoiceUrl = (rowData) => {
    const invoiceUrl = rowData?.invoiceUrl;

    const width = 800;
    const height = 600;

    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    window.open(
      invoiceUrl,
      "invoicePopup",
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
  };
  activateCanceledSubscription(data) {
    const postObject = {
      header: this.header,
      subscription: {
        id: data.id,
      },
    };

    FetchServerData.callPostService(
      "/paymentms/activateCanceledSubscription",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          this.getBillingDetails();
        } else {
        }
      })
      .catch((error) => { });
  }

  sendDptextPlanInfoToBackend() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/appuserms/sendDptextPlanInfo",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
        } else {
        }
      })
      .catch((error) => { });
  }

  render() {
    this.billingReceiptDialogueRef = React.createRef();
    if (this.state.action === "view") {
      return this.viewBilling();
    } else if (this.state.action === "createCreditCard") {
      return this.createCreditCard();
    } else if (this.state.action === "editCreditCard") {
      return this.editCreditCard();
    } else if (this.state.action === "PurchasePlan") {
      return (
        <PurchasePlan
          pageId={this.state.pageId}
          subscriptionId={this.state.subscriptionId}
          planId={this.state.planId}
        />
      );
    }
  }

  viewBilling() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <div className="row" style={{ padding: "0em 0em" }}>
            {this.state.subscriptions.length > 1 ? (
              <div className="col-md-12 materialTable">
                <MaterialTable
                  title="Plan and Subscription"
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    {
                      title: <span style={{ paddingLeft: "14px" }}>#</span>,
                      render: (rowData) => (
                        <span style={{ paddingLeft: "14px" }}>
                          {rowData.tableData.id + 1}
                        </span>
                      ),
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Event Name",
                      field: "eventName",
                      cellStyle: {
                        width: "20%",
                      },
                    },
                    {
                      title: "Type",
                      field: "subscriptionType",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Amount $",
                      // field: "totalAmount",
                      render: (rowData) =>
                        `${rowData.currencySymbol !== null
                          ? rowData.customerPlan?.currencySymbol
                          : ""
                        }${rowData.customerPlan?.price > 0
                          ? Utils.formatWithCommas(
                            rowData.customerPlan?.price
                          )
                          : "NA"
                        }`,
                      customSort: (a, b) => {
                        return (
                          parseFloat(a.customerPlan?.price) -
                          parseFloat(b.customerPlan?.price)
                        );
                      },
                      cellStyle: {
                        width: "12%",
                      },
                    },

                    {
                      title: "Text Credits",
                      field: "smsCredits",
                      render: (rowData) =>
                        Utils.formatWithCommas(
                          rowData.customerPlan?.smsCredits
                        ),
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Start Date",
                      field: "subscriptionStartdate",
                      cellStyle: {
                        width: "12%",
                      },
                    },
                    {
                      title: "End Date",
                      field: "subscriptionEnddate",
                      cellStyle: {
                        width: "15%",
                      },
                    },

                    {
                      title: "Status",
                      field: "subscriptionStatus",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                  ]}
                  data={this.state.subscriptions}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.subscriptions?.length > 10 ? true : false,
                  }}
                />
              </div>
            ) : (
              <div className="col-md-12">
                <div
                  className="card "
                  id="giveBeeCardTopBoxShadowremove"
                  style={{ borderRadius: "0rem" }}
                >
                  <div
                    className="card-header d-flex align-items-center justify-content-between p-2"
                    id="assetCardHeader"
                  >
                    <h6 className="mb-0" id="headerLabel">
                      Plan and Subscription
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {this.state.subscriptions.map((value, index) => (
                        <>
                          <div className="row ps-0 align-items-stretch">
                            <div className="col-md-3">
                              <div
                                className="row d-flex"
                                style={{
                                  height: "100%",
                                }}
                              >
                                <div className="col-md-12 mt-4">
                                  <div
                                    className="row d-flex"
                                    style={{
                                      height: "100%",
                                    }}
                                  >
                                    <div className="col-md-12">
                                      <div
                                        className="box"
                                        data-aos="zoom-in"
                                        data-aos-delay={100}
                                        style={{
                                          padding: "0em",
                                          position: "relative",
                                          height: "100%",
                                        }}
                                        id="regPlanBox"
                                      >
                                        <div
                                          className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                          style={{
                                            height: "100%",
                                          }}
                                        >
                                          <div
                                            className="entry-title plan_card"
                                            style={{
                                              background:
                                                value?.customerPlan
                                                  ?.colorSecondary,
                                            }}
                                          >
                                            <h3
                                              className="plan_card"
                                              style={{
                                                padding: "7px",
                                                color: "#fff",
                                                background:
                                                  value?.customerPlan
                                                    ?.colorPrimary,
                                              }}
                                            >
                                              {value?.customerPlan?.name}
                                            </h3>
                                            <div
                                              className="price"
                                              style={{
                                                background:
                                                  value?.customerPlan
                                                    ?.colorPrimary,
                                              }}
                                            >
                                              <span
                                                style={{
                                                  left: "20px",
                                                }}
                                              >
                                                {`$${Utils.formatWithCommas(
                                                  value?.customerPlan?.price
                                                )}`}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="entry-content flex-grow-1 d-flex flex-column">
                                            <ul
                                              className={
                                                this.businessDomain !==
                                                  BUSINESS_DOMAIN.dpText
                                                  ? "flex-grow-1"
                                                  : "flex-grow-1 pb-4"
                                              }
                                            >
                                              {value?.customerPlan?.planItems.map(
                                                (item, i) => (
                                                  <li
                                                    key={i}
                                                    style={{
                                                      padding: "0.2em",
                                                      fontWeight:
                                                        item?.isFontBold &&
                                                        "600",
                                                      fontStyle:
                                                        item?.isFontItalic &&
                                                        "italic",
                                                    }}
                                                  >
                                                    {item.name}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                            {index === 0 &&
                                              (Utils.equalsIgnoreCase(
                                                value.subscriptionStatus,
                                                "Active"
                                              ) ||
                                                Utils.equalsIgnoreCase(
                                                  value.subscriptionStatus,
                                                  "Completed"
                                                )) &&
                                              this.businessDomain !==
                                              BUSINESS_DOMAIN.dpText &&
                                              this.state.businessUseCase
                                                ?.name !==
                                              "Text-based fundraising and communication at a single event" && (
                                                <div className="row p-3">
                                                  {!value?.customerPlan
                                                    ?.highestPlan && (
                                                      <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                        <div className="btn_plan1">
                                                          <a
                                                            style={{
                                                              borderRadius:
                                                                "10px",
                                                              backgroundColor:
                                                                value
                                                                  ?.customerPlan
                                                                  ?.colorPrimary,
                                                            }}
                                                            onClick={() =>
                                                              this.upgradePlanListForUseCase(
                                                                value?.customerPlan
                                                              )
                                                            }
                                                          >
                                                            Upgrade Plan
                                                          </a>
                                                        </div>
                                                      </div>
                                                    )}
                                                </div>
                                              )}

                                            {index === 0 &&
                                              this.businessDomain !==
                                              BUSINESS_DOMAIN.dpText && (
                                                <>
                                                  {!Utils.equalsIgnoreCase(
                                                    value.subscriptionStatus,
                                                    "Active"
                                                  ) &&
                                                    !Utils.equalsIgnoreCase(
                                                      value.subscriptionStatus,
                                                      "Completed"
                                                    ) && (
                                                      <div className="row p-3">
                                                        <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                                          <div className="btn_plan1">
                                                            <a
                                                              style={{
                                                                borderRadius:
                                                                  "10px",
                                                                backgroundColor:
                                                                  value
                                                                    ?.customerPlan
                                                                    ?.colorPrimary,
                                                              }}
                                                              onClick={this.getPlanListForUseCase.bind(
                                                                this
                                                              )}
                                                            >
                                                              Purchase
                                                            </a>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}
                                                </>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* <div className="row mt-2">
                                {index === 0 &&
                                  this.businessDomain !==
                                    BUSINESS_DOMAIN.dpText && (
                                    <>
                                      {!Utils.equalsIgnoreCase(
                                        value.subscriptionStatus,
                                        "Active"
                                      ) &&
                                        !Utils.equalsIgnoreCase(
                                          value.subscriptionStatus,
                                          "Completed"
                                        ) && (
                                          <div className="col-md-12">
                                            <Button
                                              style={{
                                                background: "rgb(242, 109, 33)",
                                                color: "rgb(255, 255, 255)",
                                                borderBottom:
                                                  "3px solid rgb(99, 98, 98)",
                                                borderRadius: "5px",
                                                // width: "120px",
                                                padding: "5px 10px",
                                                textTransform: "capitalize",
                                              }}
                                              onClick={this.getPlanListForUseCase.bind(
                                                this
                                              )}
                                            >
                                              Purchase Subscription
                                            </Button>
                                          </div>
                                        )}
                                    </>
                                  )}
                              </div> */}
                            </div>
                            <div
                              className="col-md-6 align-self-center"
                              style={{ padding: "40px", height: "100%" }}
                            >
                              {value.eventName !== null && (
                                <div className="row">
                                  <label
                                    className="col-sm-3 col-form-label fw-bold"
                                    htmlFor="basic-default-name"
                                    id="assetFormLabel"
                                  >
                                    Event Name
                                  </label>
                                  <div
                                    className="col-sm-9"
                                    id="OrganizationCol"
                                  >
                                    <span>{value.eventName}</span>
                                  </div>
                                </div>
                              )}
                              {this.businessDomain ===
                                BUSINESS_DOMAIN.dpText ?
                                (
                                  <>
                                    <div className="row">
                                      <label
                                        className="col-sm-4 col-form-label fw-bold"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      >
                                        {Utils.equalsIgnoreCase(this.planType, "Onetime") ? "Event Start Date " : "Current Cycle Start Date"}
                                      </label>
                                      <div className="col-sm-8" id="OrganizationCol">
                                        <span>{value.subscriptionStartdate}</span>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <label
                                        className="col-sm-4 col-form-label fw-bold"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      >
                                        {Utils.equalsIgnoreCase(this.planType, "Onetime") ? "Event End Date " : "Current Cycle End Date"}
                                      </label>
                                      <div className="col-sm-8" id="OrganizationCol">
                                        <span>{value.subscriptionEnddate}</span>
                                      </div>
                                    </div>
                                    {/* <div className="row mt-4">
                                      <div className="col-sm-12" id="OrganizationCol">
                                        <p className="mb-0 me-2 align-self-center">
                                          Ready to upgrade your plan?
                                          <a
                                            className="anchortag ms-1"
                                            href={`mailto: support@dptext.org`}
                                            rel="noopener noreferrer"
                                          >
                                            Request info
                                          </a>
                                        </p>
                                      </div>
                                    </div> */}
                                    <div className="row" style={{ alignItems: "end", minHeight: "90%" }}>
                                      <div className="col-sm-12">
                                        <p className="mb-0">
                                          Ready to upgrade your plan?
                                          <span
                                            className="anchortag ms-1 cursor-pointer"
                                            onClick={this.sendDptextPlanInfoToBackend.bind(this)}
                                          >
                                            Request info
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                )
                                :
                                (
                                  <>
                                    <div className="row">
                                      <label
                                        className="col-sm-3 col-form-label fw-bold"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      >
                                        Start Date
                                      </label>
                                      <div className="col-sm-9" id="OrganizationCol">
                                        <span>{value.subscriptionStartdate}</span>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <label
                                        className="col-sm-3 col-form-label fw-bold"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      >
                                        End Date
                                      </label>
                                      <div className="col-sm-9" id="OrganizationCol">
                                        <span>{value.subscriptionEnddate}</span>
                                      </div>
                                    </div>
                                    {!Utils.equalsIgnoreCase(this.planType, "Onetime") &&
                                      <div className="row">
                                        <label
                                          className="col-sm-3 col-form-label fw-bold pe-0"
                                          htmlFor="basic-default-name"
                                          id="assetFormLabel"
                                        >
                                          Next Billing Date
                                        </label>
                                        <div
                                          className="col-sm-9"
                                          id="OrganizationCol"
                                        >
                                          <span>
                                            {value.nextBillingDate !== null
                                              ? value.nextBillingDate
                                              : ""}
                                          </span>
                                        </div>
                                      </div>
                                    }
                                  </>
                                )}
                              {Utils.equalsIgnoreCase(
                                value.subscriptionStatus,
                                "Cancelled"
                              ) && (
                                  <div className="row">
                                    <label
                                      className={this.businessDomain === BUSINESS_DOMAIN.dpText ? "col-sm-4 col-form-label fw-bold" : "col-sm-3 col-form-label fw-bold"}
                                      htmlFor="basic-default-name"
                                      id="assetFormLabel"
                                    >
                                      Status
                                    </label>
                                    <div className={this.businessDomain === BUSINESS_DOMAIN.dpText ? "col-sm-8 align-self-center" : "col-sm-9 align-self-center"} id="givbeeText">
                                      <span className="pe-4">
                                        {value.subscriptionStatus}
                                      </span>
                                      <Button
                                        id="ptsHollowButton"
                                        variant="contained"
                                        style={{ textTransform: "initial" }}
                                        type="button"
                                        onClick={this.activateCanceledSubscription.bind(
                                          this,
                                          value
                                        )}
                                      >
                                        Activate Subscription
                                      </Button>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </div>
                          {/* {this.businessDomain ===
                            BUSINESS_DOMAIN.dpText &&
                            <div className="row ps-0">
                              <div className="col-md-3"></div>
                              <div className="col-md-9 d-flex" style={{ paddingLeft: "40px" }}>
                                <p className="mb-0 me-2 align-self-center">
                                  Ready to upgrade your plan?
                                  <a
                                    className="anchortag ms-1"
                                    href={`mailto: support@dptext.org`}
                                    rel="noopener noreferrer"
                                  >
                                    Request info
                                  </a>
                                </p>
                              </div>
                            </div>
                          } */}
                        </>
                      ))}
                      {this.state.subscriptions.length === 0 && (
                        <div className="col-md-4">
                          <Button
                            style={{
                              background: "rgb(242, 109, 33)",
                              color: "rgb(255, 255, 255)",
                              borderBottom: "3px solid rgb(99, 98, 98)",
                              borderRadius: "5px",
                              // width: "120px",
                              padding: "5px 10px",
                              textTransform: "capitalize",
                            }}
                            onClick={this.getPlanListForUseCase.bind(this)}
                          >
                            Purchase Subscription
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            id="savedCreditCardsSection"
            className="materialTable creditCard mt-3 card"
            style={{ width: "100%" }}
          >
            <MaterialTable
              title="Saved Credit Cards"
              icons={UiUtils.getMaterialTableIcons()}
              // onRowClick={(event, rowData) => {
              //   this.toEditCreditCardDetails(event, rowData);
              //   event.stopPropagation();
              // }}
              localization={{
                body: {
                  emptyDataSourceMessage: (
                    <h5 className="dataNotAvailable">No data found.</h5>
                  ),
                },
              }}
              columns={[
                // {
                //   title: "#",
                //   render: (rowData) => rowData.tableData.id + 1,
                //   width: "5%",
                //   align: "left",
                //   cellStyle: {
                //     width: "6%",
                //   },
                // },
                {
                  title: "Name on Card",
                  field: "fullName",
                  cellStyle: {
                    width: "20%",
                  },
                },
                {
                  title: "Card Type",
                  field: "type",
                  cellStyle: {
                    width: "15%",
                  },
                },
                {
                  title: "Card Number",
                  field: "number",
                  cellStyle: {
                    width: "22%",
                  },
                },
                {
                  title: "Card Expiration Date",
                  render: (rowData) => (
                    <>
                      <span
                        style={{ display: "inline-block", minWidth: "55px" }}
                      >
                        {`${rowData.month}/${rowData.year}`}
                      </span>
                      {rowData.isExpired && (
                        <span
                          className="ps-2"
                          style={{ color: "#990000", fontWeight: "bold" }}
                        >
                          Expired
                        </span>
                      )}
                    </>
                  ),
                  align: "left",
                  cellStyle: {
                    width: "19%",
                  },
                },
                {
                  title: "Actions",
                  disableClick: true,
                  sorting: false,
                  render: (rowData) => (
                    <div
                      key={rowData.id}
                      style={{
                        display: "flex",
                        // justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {rowData.isDefault ? (
                        <span
                          style={{
                            fontWeight: "500",
                            color: "#353538",
                            paddingLeft: "12px",
                          }}
                        >
                          Default
                        </span>
                      ) : (
                        <>
                          {!rowData.isExpired && (
                            <Button
                              variant="contained"
                              size="small"
                              style={{
                                background: "#d3d8de",
                                color: "#353538",
                                textTransform: "capitalize",
                              }}
                              onClick={() =>
                                this.setDefaultCardToBackend(rowData)
                              }
                            >
                              Make Default
                            </Button>
                          )}
                          <span className="ps-2">
                            <DeleteButton
                              domainObject={rowData.fullName}
                              pageId="cardDelete"
                              onClick={() =>
                                this.deleteCreditCardToBackend(rowData)
                              }
                            />
                          </span>
                        </>
                      )}
                    </div>
                  ),
                },
              ]}
              data={this.state.creditCardList?.sort((a, b) =>
                a.isDefault === b.isDefault ? 0 : a?.isDefault ? -1 : 1
              )}
              options={{
                emptyRowsWhenPaging: false,
                sorting: true,
                search: false,
                actionsColumnIndex: -1,
                initialPage: this.state.initialPage,
                pageSize: this.state.pageSize,
                pageSizeOptions: Utils.materialTablePageSize(),
                paging: false,
              }}
              detailPanel={(rowData) =>
                rowData.paymentList !== null && (
                  <>
                    <div
                      className="row d-flex justify-content-end"
                      style={{ padding: "10px" }}
                    >
                      {rowData.paymentList.length > 0 ? (
                        <>
                          <table class="table treeTable">
                            <thead>
                              <tr style={{ textTransform: "capitalize" }}>
                                {/* <th scope="col"></th> */}
                                {/* <th scope="col">#</th> */}
                                <th scope="col"> Type</th>
                                <th scope="col"> Amount</th>
                                {/* <th scope="col"> Payment Date</th> */}
                                <th scope="col"> Start Date</th>
                                <th scope="col">End Date</th>
                                <th scope="col"> Transaction ID</th>
                                <th scope="col">Status</th>
                              </tr>
                            </thead>
                            <tbody>{this.renderTableRows(rowData)}</tbody>
                          </table>
                          {rowData.paymentList.length > 10 && (
                            <div className="pagination justify-content-end">
                              {this.renderPagination(rowData)}
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="text-center">
                          <h5 className="dataNotAvailable">No data found.</h5>
                        </div>
                      )}
                    </div>
                  </>
                )
              }
              onChangePage={(page, pageSize) => {
                this.handleMaterialTablePageChange(page, pageSize);
              }}
              actions={[
                {
                  icon: () => (
                    <PtsButton btnName="Add Credit Card" type="submit" />
                  ),
                  isFreeAction: true,
                  onClick: (event) => this.handleAddCreditCardOpen(),
                },
                //   (rowData) =>
                //     rowData && {
                //       icon: () => (
                //         <Button
                //           variant="contained"
                //           size="small"
                //           style={{
                //             background: "#d3d8de",
                //             color: "#353538",
                //             float: "right",
                //             textTransform: "capitalize",
                //           }}
                //           startIcon={<EditIcon />}
                //           onClick={this.toEditCreditCardDetails.bind(
                //             this,
                //             rowData
                //           )}
                //         >
                //           Edit
                //         </Button>
                //       ),
                //     },
                //   (rowData) =>
                //     rowData && {
                //       icon: () => (
                //         <DeleteIconButton
                //           domainObject={rowData.number}
                //           pageId="Credit Card"
                //           onClick={this.deleteCraditCardInBackend.bind(
                //             this,
                //             rowData
                //           )}
                //         />
                //       ),
                //     },
              ]}
            />
          </div>

          {this.businessDomain !== BUSINESS_DOMAIN.dpText && (
            <div className="materialTable mt-3 card subscriptionTable" style={{ width: "100%" }}>
              <>
                <MaterialTable
                  title={Utils.equalsIgnoreCase(this.planType, "Onetime") ? "Per Event Charges" : "Subscription Charges"}
                  onRowClick={(event, rowData) => {
                    this.toReceiptDetails(event, rowData);
                    event.stopPropagation();
                  }}
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    {
                      title: <span style={{ paddingLeft: "14px" }}>#</span>,
                      render: (rowData) => (
                        <span style={{ paddingLeft: "14px" }}>
                          {rowData.tableData.id + 1}
                        </span>
                      ),
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    !Utils.equalsIgnoreCase(this.planType, "Onetime") && {
                      title: "Type",
                      field: "subscriptionType",
                      render: (rowData) => {
                        if (rowData.isOverages) {
                          return "Overages";
                        }

                        if (rowData.subscriptionType && rowData.bonusCredits > 0) {
                          return `${rowData.subscriptionType} + Bonus (${rowData.bonusCredits})`;
                        }

                        return rowData.subscriptionType || "";
                      },
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    this.businessDomain === BUSINESS_DOMAIN.eventText &&
                    Utils.equalsIgnoreCase(this.planType, "Onetime") && {
                      title: "Event name",
                      field: "eventName",
                      cellStyle: {
                        width: "15%",
                      },
                    },

                    {
                      title: "Amount $",
                      // field: "totalAmount",
                      render: (rowData) =>
                        `${rowData.currencySymbol !== null
                          ? rowData.currencySymbol
                          : ""
                        }${rowData.isOverages
                          ? rowData.overageCharges
                          : rowData.paidAmount
                        }`,
                      customSort: (a, b) => {
                        return (
                          parseFloat(a.paidAmount) - parseFloat(b.paidAmount)
                        );
                      },
                      cellStyle: {
                        width: "10%",
                      },
                    },
                    {
                      title: "Text Usage",
                      render: (rowData) => {
                        const used = rowData.consumedCredits ?? 0;
                        const avail = rowData.availableCredits ?? 0;
                        return (
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                            }}
                          >
                            <span>{`${used} / ${avail}`}</span>
                          </div>
                        );
                      },
                      customSort: (a, b) => {
                        const usedA = a.consumedCredits ?? 0;
                        const availA = a.availableCredits ?? 1; // prevent divide by zero
                        const percentA = usedA / availA;

                        const usedB = b.consumedCredits ?? 0;
                        const availB = b.availableCredits ?? 1;
                        const percentB = usedB / availB;

                        return percentA - percentB;
                      },
                      cellStyle: { width: "12%" },
                    },
                    // {
                    //   title: "Overages $",
                    //   render: (rowData) => {
                    //     if (rowData.isOverages) {
                    //       return "NA";
                    //     }

                    //     if (rowData.overageCharges > 0) {
                    //       if (rowData.overageDescription) {
                    //         return (
                    //           <Tooltip
                    //             title={rowData.overageDescription}
                    //             arrow
                    //             classes={{ popper: "custom-tooltip" }}
                    //           >
                    //             <span>
                    //               {rowData.currencySymbol ?? ""}
                    //               {rowData.overageCharges}
                    //             </span>
                    //           </Tooltip>
                    //         );
                    //       }

                    //       return (
                    //         <span>
                    //           {rowData.currencySymbol ?? ""}
                    //           {rowData.overageCharges}
                    //         </span>
                    //       );
                    //     }

                    //     return "NA";
                    //   },
                    //   customSort: (a, b) =>
                    //     parseFloat(a.overageCharges) -
                    //     parseFloat(b.overageCharges),
                    //   cellStyle: { width: "15%" },
                    // },
                    {
                      title: "Start Date",
                      field: "cycleStartDate",
                      cellStyle: {
                        width: "13%",
                      },
                    },
                    {
                      title: "End Date",
                      field: "cycleEndDate",
                      cellStyle: {
                        width: "13%",
                      },
                    },
                    {
                      title: "Transaction ID",
                      field: "transactionId",
                      cellStyle: {
                        width: "16%",
                      },
                    },
                    {
                      title: "Payment",
                      field: "paymentStatus",
                      render: (rowData) => (
                        <div className="d-flex action-button">
                          <span style={{ width: "80px" }}>
                            {rowData.paymentStatus}
                          </span>
                          {rowData.paymentStatus === "Unpaid" && (
                            <Button
                              style={{
                                background: "rgb(33, 148, 242)",
                                color: "rgb(255, 255, 255)",
                                borderBottom: "3px solid rgb(99, 98, 98)",
                                borderRadius: "5px",
                                padding: "2px 10px",
                                fontSize: "20px",
                                fontWeight: "700",
                                textTransform: "capitalize",
                              }}
                              type="button"
                              onClick={() => this.goToInvoiceUrl(rowData)}
                            >
                              Pay now
                            </Button>
                          )}
                        </div>
                      ),
                      cellStyle: {
                        width: "28%",
                      },
                    },
                    // {
                    //   title: "View",
                    //   render: (rowData) => {
                    //     return (
                    //       <IconButton
                    //         aria-label="toggle password visibility"
                    //         onClick={this.toReceiptDetails.bind(this, rowData)}
                    //       >
                    //         <c />
                    //       </IconButton>
                    //     );
                    //   },
                    //   headerStyle: {
                    //     textAlign: "center",
                    //   },
                    //   cellStyle: {
                    //     width: "8%",
                    //     textAlign: "center",
                    //   },
                    // },
                  ].filter(Boolean)}
                  data={this.state.customerPaymentList}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isPaging,
                  }}
                  components={{
                    Row: React.forwardRef((props, ref) => {
                      const text = props.data?.overageDescription || "";

                      if (!text) {
                        return <MTableBodyRow ref={ref} {...props} />;
                      }
                      return (
                        <Tooltip
                          title={text}
                          arrow
                          followCursor
                          classes={{ popper: "custom-tooltip" }}
                        >
                          <MTableBodyRow ref={ref} {...props} />
                        </Tooltip>
                      );
                    }),
                  }}
                  actions={[
                    // (rowData) =>
                    //   rowData?.status !== "Completed" &&
                    //   rowData?.status !== "Active" && {
                    //     icon: () => (
                    //       <DeleteIconButton
                    //         domainObject={rowData.name}
                    //         onClick={this.deleteCoustomerOrder.bind(
                    //           this,
                    //           rowData
                    //         )}
                    //       />
                    //     ),
                    //   },
                    {
                      icon: () => (
                        <span
                          className="text-end ms-2"
                          style={{ fontSize: "13px", fontWeight: "600", color: "#337ab7" }}
                        >
                          <NavLink
                            className="navLink"
                            onClick={this.handleOpenAuthorized.bind(this)}
                          >
                            Close Account
                          </NavLink>
                        </span>
                      ),
                      isFreeAction: true,
                      // onClick: (event) => this.handleOpenAuthorized(event),
                    },
                  ]}
                />
              </>
            </div>
          )}
          {this.state.overagePaymentList.length > 0 && (
            <div
              className="materialTable"
              style={{ width: "100%", marginTop: "25px" }}
            >
              <>
                <MaterialTable
                  title="Overages Charges"
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    {
                      title: <span style={{ paddingLeft: "14px" }}>#</span>,
                      render: (rowData) => (
                        <span style={{ paddingLeft: "14px" }}>
                          {rowData.tableData.id + 1}
                        </span>
                      ),
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Plan",
                      field: "subscriptionType",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Amount",
                      // field: "totalAmount",
                      render: (rowData) =>
                        `${rowData.currencySymbol !== null
                          ? rowData.currencySymbol
                          : ""
                        }${rowData.paidAmount}`,
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Payment Date",
                      field: "orderDate",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "Payment",
                      field: "paymentStatus",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "View",
                      render: (rowData) => {
                        return (
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={this.toReceiptDetails.bind(this, rowData)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        );
                      },
                      headerStyle: {
                        textAlign: "center",
                      },
                      cellStyle: {
                        width: "8%",
                        textAlign: "center",
                      },
                    },
                  ]}
                  data={this.state.overagePaymentList}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: false,
                  }}
                // actions={[
                //   (rowData) =>
                //     rowData?.status !== "Completed" &&
                //     rowData?.status !== "Active" && {
                //       icon: () => (
                //         <DeleteIconButton
                //           domainObject={rowData.name}
                //           onClick={this.deleteCoustomerOrder.bind(
                //             this,
                //             rowData
                //           )}
                //         />
                //       ),
                //     },
                // ]}
                />
              </>
            </div>
          )}
          <BillingReceipt
            ref={this.billingReceiptDialogueRef}
            style={{ float: "right" }}
          />
          <Dialog
            open={this.state.open}
            onClose={this.handleClose.bind(this)}
            maxWidth="xl"
            className="planPurchaseDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff", fontWeight: "600" }}>Plans</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <div
                md={12}
                style={{
                  width: "100%",
                  color: "#000",
                  fontSize: "small",
                  padding: "0.5em",
                }}
              >
                <div className="row mt-2">
                  <div className="col-md-12">
                    <p className="mb-0" style={{ fontSize: "14px" }}>
                      Any unused credits from your current plan will be applied
                      to your new plan. Overages from the current plan will be
                      deducted from your new plan's credits.
                    </p>
                  </div>
                  <div className="col-md-12">
                    <div className="row d-flex align-item-stretch">
                      {this.state.planList.map((plan, index) => (
                        <div className="col-md-3 mt-4">
                          <div
                            className="row d-flex"
                            style={{
                              height: "100%",
                            }}
                          >
                            <div className="col-md-12">
                              <div
                                className="box"
                                data-aos="zoom-in"
                                data-aos-delay={100}
                                style={{
                                  padding: "0em",
                                  position: "relative",
                                  height: "100%",
                                }}
                                id="regPlanBox"
                              >
                                <div
                                  className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                  style={{
                                    height: "100%",
                                  }}
                                >
                                  <div
                                    class="entry-title plan_card"
                                    style={{
                                      background: plan.colorSecondary,
                                    }}
                                  >
                                    <h3
                                      class="plan_card"
                                      style={{
                                        padding: "7px",
                                        color: "#fff",
                                        background: plan.colorPrimary,
                                      }}
                                    >
                                      {plan.name}
                                    </h3>
                                    <div
                                      class="price"
                                      style={{
                                        background: plan.colorPrimary,
                                      }}
                                    >
                                      <span
                                        style={{
                                          left: "20px",
                                        }}
                                      >
                                        {`$${Utils.formatWithCommas(
                                          plan.price
                                        )}`}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="entry-content flex-grow-1 d-flex flex-column">
                                    <ul className="flex-grow-1">
                                      {plan?.planItems.map(
                                        (planItem, index) => (
                                          <li
                                            style={{
                                              padding: "0.2em",
                                              fontWeight:
                                                planItem?.isFontBold && "600",
                                              fontStyle:
                                                planItem?.isFontItalic &&
                                                "italic",
                                              fontSize:
                                                planItem?.isFontSmall && "12px",
                                            }}
                                          >
                                            {planItem.name}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                    <div className="row p-3">
                                      <div className="buy_now_btn2 col-md-12 text-center mt-auto">
                                        <div className="btn_plan1">
                                          <a
                                            style={{
                                              borderRadius: "10px",
                                              backgroundColor:
                                                plan.colorPrimary,
                                            }}
                                            onClick={this.customerOrderpurchasePlan.bind(
                                              this,
                                              plan
                                            )}
                                          >
                                            Select
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </DialogContent>
          </Dialog>
          <Dialog
            open={this.state.authorizedCaregiver}
            onClose={this.handleAuthorizedClose.bind(this)}
            onHide={this.close}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <Row style={{ marginRight: "auto", marginLeft: "auto" }}>
                <Col md={12} style={{ textAlign: "center" }}>
                  <ErrorOutlineIcon
                    style={{
                      border: "2px solid #fff",
                      borderRadius: "25%",
                      background: "#066f72 !important",
                      color: "red",
                      fontSize: "50px",
                    }}
                  />
                </Col>
              </Row>

              <span style={{ textAlign: "center" }}>
                <p className="m-0" style={{ fontSize: "18px" }}>
                  Are you sure you want to close your account? <br />
                  By doing so, your account will no longer be active and your
                  texting number will be released.
                </p>
              </span>
            </DialogContent>
            <DialogActions
              style={{
                padding: "1em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "none"
                }}
                onClick={(e) => this.toDeleteAuthorizedConfirmationWindow(e)}
              >
                Yes, I want to close my account
              </Button>
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "none"
                }}
                onClick={this.handleAuthorizedClose.bind(this)}
              >
                Keep account
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.confirmWindowOpen}
            onClose={this.handleConfirmWindowClose.bind(this)}
            onHide={this.close}
            style={{ padding: "1em" }}
          >
            <DialogContent style={{ marginTop: "2em" }}>
              <span style={{ textAlign: "center" }}>
                <h2 style={{ fontSize: "20px" }}>
                  Please enter your Password{" "}
                </h2>
              </span>
              <Row className="mt-4">
                <Col
                  md={12}
                  style={{ marginLeft: "auto", marginRight: "auto" }}
                >
                  <TextField
                    variant="outlined"
                    margin="normal"
                    size="small"
                    title=""
                    required
                    fullWidth
                    autoFocus={true}
                    name="password"
                    type={this.state.showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="off"
                    onChange={this.handlePasswordChange.bind(this)}
                    value={this.state.accountPassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={this.handleClickShowPassword.bind(this)}
                          >
                            {this.state.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Col>
              </Row>
            </DialogContent>
            <DialogActions
              style={{
                padding: "2em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<SaveIcon />}
                onClick={(e) => this.deleteProfileInBackend(e)}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                size="large"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleConfirmWindowClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={this.state.openAddCreditCard}
            onClose={this.handleAddCreditCardClose.bind(this)}
            maxWidth="xl"
            className="creditCardDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Add New Card</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleAddCreditCardClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <Elements stripe={stripePromise}>
                <ElementsConsumer>
                  {({ stripe, elements }) => (
                    <div
                      md={12}
                      style={{
                        width: "100%",
                        color: "#000",
                        fontSize: "small",
                        padding: "0.5em",
                      }}
                    >
                      <div className="row d-flex align-item-stretch justify-content-center">
                        <div class="col-md-11 align-self-center">
                          {/* <form
                            onSubmit={this.addNewCreditCard.bind(
                              this,
                              stripe,
                              elements
                            )}
                            style={styles.form}
                          > */}
                          <div className="row">
                            <div className="col-sm-12">
                              <h4>Add a new credit card.</h4>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <label className="form-label">Name on Card</label>
                              <input
                                name="name"
                                value={this.state.cardName}
                                onChange={this.handleCardNameChange.bind(this)}
                                required
                                style={styles.input}
                                placeholder=""
                              />
                            </div>
                          </div>

                          <div className="row  mt-3">
                            <div className="col-md-12">
                              <label className="form-label">Card Number</label>
                              <div style={styles.inputBox}>
                                <CardNumberElement
                                  options={{ placeholder: "" }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label className="form-label">
                                Expiration (MM/YY)
                              </label>
                              <div style={styles.inputBox}>
                                <CardExpiryElement
                                  options={{ placeholder: "" }}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label">CVV</label>
                              <div style={styles.inputBox}>
                                <CardCvcElement options={{ placeholder: "" }} />
                              </div>
                            </div>
                          </div>
                          <div className="row  mt-3">
                            <div className="col-md-12">
                              <span className="billingcardCheckboxSize">
                                <FormControlLabel
                                  style={{
                                    color: "#000",
                                    width: "100%",
                                    margin: "0",
                                    padding: "0",
                                    alignItems: "flex-start",
                                  }}
                                  control={
                                    <Checkbox
                                      variant="outlined"
                                      id="isAsset"
                                      checked={this.state.isDefault}
                                      value={this.state.isDefault}
                                      onChange={this.handleIDefaultChange.bind(
                                        this
                                      )}
                                      style={{
                                        padding: "0",
                                        marginRight: "6px",
                                        transform: "scale(0.9)",
                                        alignSelf: "self-start",
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      className="form-label"
                                      style={{
                                        fontSize: "14px",
                                        lineHeight: "18px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      Make default card
                                    </span>
                                  }
                                />
                              </span>
                            </div>

                          </div>
                          <div className="row mt-2">
                            <div
                              className="col-12 d-flex align-items-start flex-wrap"
                              id="assetFormLabel"
                            >
                              <span className="billingcardCheckboxSize">
                                <FormControlLabel
                                  style={{
                                    color: "#000",
                                    width: "100%",
                                    margin: "0",
                                    padding: "0",
                                    alignItems: "flex-start",
                                  }}
                                  control={
                                    <Checkbox
                                      id="isChecked"
                                      checked={this.state.isOverageFeeAgreement}
                                      value={this.state.isOverageFeeAgreement}
                                      onChange={this.handleIsOverageFeeAgreementChange.bind(
                                        this
                                      )}
                                      style={{
                                        padding: "0",
                                        marginRight: "6px",
                                        transform: "scale(0.9)",
                                        alignSelf: "self-start",
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      className="form-label fw-normal"
                                      style={{
                                        fontSize: "14px",
                                        lineHeight: "18px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      I hereby agree and acknowledge that this card may be used to pay applicable text overages fees according to this account's subscription plan.
                                    </span>
                                  }
                                />
                              </span>
                            </div>
                          </div>
                          <div class="row text-center mt-2">
                            <div className="col-sm-12">
                              <Button
                                style={{
                                  background: "rgb(33, 148, 242)",
                                  color: "rgb(255, 255, 255)",
                                  borderBottom: "3px solid rgb(99, 98, 98)",
                                  borderRadius: "5px",
                                  padding: "2px 10px",
                                  fontSize: "20px",
                                  fontWeight: "700",
                                  textTransform: "capitalize",
                                  width: "100%",
                                  opacity: this.state.isOverageFeeAgreement ? 1 : 0.5,
                                  cursor: this.state.isOverageFeeAgreement ? "pointer" : "not-allowed",
                                }}
                                type="button"
                                disabled={!this.state.isOverageFeeAgreement}
                                onClick={(e) =>
                                  this.addNewCreditCard(e, stripe, elements)
                                }
                              >
                                Add Card
                              </Button>
                            </div>
                          </div>
                          {this.state.error && (
                            <div className="row" style={{ color: "#e53e3e" }}>
                              <div className="col-sm-12">
                                {this.state.error}
                              </div>
                            </div>
                          )}
                          {this.state.success && (
                            <div className="row" style={{ color: "#38a169" }}>
                              <div className="col-sm-12">
                                Card saved successfully!
                              </div>
                            </div>
                          )}
                          <div className="row mt-2">
                            <div className="col-sm-12">
                              <img src={StripeLogo} style={{ width: "75px" }} />
                            </div>
                            <div className="col-sm-12">
                              <p className="mb-0" style={{ fontSize: "12px" }}>
                                Credit card information and payments are
                                securely managed by Stripe.
                              </p>
                            </div>
                          </div>
                          {/* </form> */}
                        </div>
                      </div>
                    </div>
                  )}
                </ElementsConsumer>
              </Elements>
            </DialogContent>
          </Dialog>
        </>
      );
    }
  }
  createCreditCard() {
    return (
      <ValidatorForm
        ref="form"
        onSubmit={this.createCreditCardToBackend.bind(this)}
      >
        {/* <div className="row" style={{ padding: "0em 0em", marginTop: "1em" }}>
          <div className="col-md-6">
            <div className="card " id="giveBeeCard">
              <div
                className="card-header d-flex align-items-center justify-content-between"
                id="assetCardHeader"
              >
                <h6 className="mb-0" id="headerLabel">
                  <b>Credit card Information</b>
                </h6>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-sm-6">
                    <label className="form-label" htmlFor="multiStepsName">
                      First Name
                    </label>
                    <input
                      required
                      type="text"
                      id="multiStepsName"
                      className="form-control"
                      name="multiStepsName"
                      value={this.state.firstName}
                      onChange={this.handleFirstNameChange.bind(this)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label" htmlFor="multiStepsName">
                      Last Name
                    </label>
                    <input
                      required
                      type="text"
                      id="multiStepsName"
                      className="form-control"
                      name="multiStepsName"
                      value={this.state.lastName}
                      onChange={this.handleLastNameChange.bind(this)}
                    />
                  </div>
                </div>
                <div className="row g-3" style={{ marginTop: "0.5em" }}>
                  <div className="col-sm-6">
                    <label className="form-label" htmlFor="multiStepsState">
                      Card Type
                    </label>
                    <select
                      required
                      autoComplete="off"
                      id="multiStepsState"
                      className="select2 form-select"
                      data-allow-clear="true"
                      value={this.state.cardType}
                      onChange={this.handleCardTypeChange.bind(this)}
                    >
                      <option value="">Select</option>
                      <option value="visa">visa</option>
                      <option value="master card">master card</option>
                      <option value="discover">discover</option>
                      <option value="American Express">american express</option>
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <label
                      className="form-label w-100"
                      htmlFor="multiStepsCard"
                    >
                      Card number
                    </label>
                    <div className="input-group input-group-merge">
                      <input
                        required
                        id="multiStepsCard"
                        autoComplete="off"
                        className="form-control multi-steps-card"
                        name="multiStepsCard"
                        type="text"
                        placeholder="1356 3215 6548 7898"
                        aria-describedby="multiStepsCardImg"
                        value={this.state.cardNumber}
                        onChange={this.handleCardNumberChange.bind(this)}
                      />
                    </div>
                  </div>
                </div>
                <div className="row g-3" style={{ marginTop: "0.5em" }}>
                  <div className="col-sm-4">
                    <label
                      className="form-label w-100"
                      htmlFor="multiStepsCard"
                    >
                      Month
                    </label>
                    <DatePicker
                      required
                      // selected={this.state.cardMonth}
                      value={this.state.cardMonth}
                      id="multiStepsExDate"
                      onChange={this.handleCardMonthChange.bind(this)}
                      className="form-control multi-steps-exp-date"
                      name="multiStepsExDate"
                      showMonthYearPicker
                      renderMonthContent={(month, shortMonth, longMonth) => {
                        return (
                          <span>{(month + 1).toString().padStart(2, 0)}</span>
                        );
                      }}
                      placeholderText="MMM"
                      dateFormat="MM"
                    />
                  </div>
                  <div className="col-sm-4">
                    <label
                      className="form-label w-100"
                      htmlFor="multiStepsCard"
                    >
                      Year
                    </label>
                    <DatePicker
                      required
                      value={this.state.cardYear}
                      // selected={this.state.cardYear}
                      id="multiStepsExDate"
                      onChange={this.handleCardYearChange.bind(this)}
                      className="form-control multi-steps-exp-date"
                      name="multiStepsExDate"
                      showYearPicker
                      placeholderText="YYYY"
                      dateFormat="yyyy"
                    />
                  </div>
                  <div className="col-sm-4">
                    <label className="form-label" htmlFor="multiStepsCvv">
                      CVV code
                    </label>
                    <div className="input-group input-group-merge">
                      <input
                        required
                        type="text"
                        autoComplete="off"
                        id="multiStepsCvv"
                        className="form-control multi-steps-cvv"
                        name="multiStepsCvv"
                        maxLength={3}
                        placeholder={654}
                        value={this.state.cvvCode}
                        onChange={this.handleCvvCodeChange.bind(this)}
                      />
                      <span
                        className="input-group-text cursor-pointer"
                        id="multiStepsCvvHelp"
                      >
                        <i
                          className="bx bx-help-circle text-muted"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Card Verification Value"
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6" id="billingAddressCol">
            <div className="card " id="giveBeeCard">
              <div
                className="card-header d-flex align-items-center justify-content-between"
                id="assetCardHeader"
              >
                <h6 className="mb-0" id="headerLabel">
                  <b>Billing Address</b>
                </h6>
              </div>
              <div className="card-body">
                <AddressWithTimezone
                  action="edit"
                  ref={this.billingAddressRef}
                  data={this.state.billingAddress}
                  onChange={this.handleBillingAddressChange.bind(this)}
                />
              </div>
            </div>
          </div>
        </div> */}
        <div
          className="row justify-content-center"
          style={{ padding: "0em 0em", marginTop: "1em" }}
        >
          <div className="col-md-6">
            <div className="card " id="giveBeeCard">
              {/* <div
                className="card-header d-flex align-items-center justify-content-between"
                id="assetCardHeader"
              >
                <h4 className="mb-0" id="headerLabel">
                  <b>Pay with debit or credit card</b>
                </h4>
              </div> */}
              <div className="card-body">
                <div class="container">
                  <div class="row justify-content-center">
                    <div class="col-md-10 align-self-center">
                      <h2>Pay with debit or credit card</h2>
                      <p>
                        We don't share your financial details with the merchant.
                      </p>
                      <div class="row">
                        <div class="mb-3">
                          <label htmlFor="country" class="form-label">
                            Country/Region
                          </label>
                          <select class="form-select" id="country">
                            <option value="">Select Country</option>
                            <option value="USA">United States</option>
                            <option value="Canada">Canada</option>
                            <option value="UK">United Kingdom</option>
                          </select>
                        </div>
                      </div>
                      <div class="row d-flex">
                        <div class="col-md-10 mb-3">
                          <label
                            className="form-label"
                            htmlFor="multiStepsState"
                          >
                            Card Type
                          </label>
                          <select
                            title=""
                            required
                            autoComplete="off"
                            id="multiStepsState"
                            className="select2 form-select"
                            data-allow-clear="true"
                            value={this.state.cardType}
                            onChange={this.handleCardTypeChange.bind(this)}
                          >
                            <option value="">Select</option>
                            <option value="visa">visa</option>
                            <option value="master card">master card</option>
                            <option value="discover">discover</option>
                            <option value="american express">
                              american express
                            </option>
                          </select>
                        </div>
                        <div class="col-md-2">{this.getIcon()}</div>
                      </div>
                      <div class="row">
                        <div class="mb-3">
                          <label htmlFor="cardNumber" class="form-label">
                            Card Number
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="cardNumber"
                            maxlength="19"
                          />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6 mb-3">
                          <label htmlFor="expiryDate" class="form-label">
                            Expiration (MM/YY)
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="expiryDate"
                            maxlength="5"
                          />
                        </div>
                        <div class="col-md-6 mb-3">
                          <label htmlFor="cvv" class="form-label">
                            CVV
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="cvv"
                            maxlength="3"
                          />
                        </div>
                      </div>
                      <h4 class="mb-3">Billing Address</h4>
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <label htmlFor="cardHolder" class="form-label">
                            First Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="cardHolder"
                          />
                        </div>
                        <div class="col-md-6">
                          <label htmlFor="cardHolder" class="form-label">
                            Last Name
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="cardHolder"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3">
                          <label htmlFor="addressLine1" class="form-label">
                            Street address
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="addressLine1"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3">
                          <label htmlFor="addressLine2" class="form-label">
                            Apt., ste., bldg.(optional)
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="addressLine2"
                          />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <label htmlFor="city" class="form-label">
                            City
                          </label>
                          <input type="text" class="form-control" id="city" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3">
                          <label htmlFor="country" class="form-label">
                            State
                          </label>
                          <select class="form-select" id="country">
                            <option value="">Select Country</option>
                            <option value="USA">United States</option>
                            <option value="Canada">Canada</option>
                            <option value="UK">United Kingdom</option>
                          </select>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <label htmlFor="zip" class="form-label">
                            ZIP Code
                          </label>
                          <input type="text" class="form-control" id="zip" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row d-flex align-items-center justify-content-between">
          <div className="col-sm-12 mt-4 text-center">
            <SaveButton id="saveButton" type="submit">
              {" "}
              Save{" "}
            </SaveButton>
            &nbsp;&nbsp;
            <CancelIconButton onClick={(e) => this.editCancel()} />
          </div>
        </div>
      </ValidatorForm>
    );
  }
  editCreditCard() {
    return (
      <>
        <ValidatorForm
          ref="form"
          onSubmit={this.updateCreditCardToBackend.bind(this)}
        >
          <div className="row" style={{ padding: "0em 0em", marginTop: "1em" }}>
            <div className="col-md-12">
              <div className="card " id="giveBeeCard">
                <div className="card-body">
                  <div class="container">
                    <div class="row  justify-content-around">
                      <div class="col-md-4 align-self-center">
                        <h3>Pay with debit or credit card</h3>
                        <p>
                          We don't share your financial details with the
                          merchant.
                        </p>

                        {/* <div class="row d-flex">
                          <label
                            className="form-label"
                            htmlFor="multiStepsState"
                          >
                            Card Type
                          </label>
                          <div class="col-md-10">
                            <select
                              title=""
                              required
                              autoComplete="off"
                              id="multiStepsState"
                              className="select2 form-select"
                              data-allow-clear="true"
                              value={this.state.cardType}
                              onChange={this.handleCardTypeChange.bind(this)}
                            >
                              <option value="">Select</option>
                              <option value="visa">visa</option>
                              <option value="master card">master card</option>
                              <option value="discover">discover</option>
                              <option value="american express">
                                american express
                              </option>
                            </select>
                          </div>
                          <div class="col-md-2 align-self-center">
                            {this.getIcon()}
                          </div>
                        </div> */}
                        <div class="row ">
                          <div class="col-md-12">
                            <label htmlFor="cardHolder" class="form-label">
                              Name on Card
                            </label>
                            <input
                              title=""
                              required
                              type="text"
                              class="form-control"
                              id="cardHolder"
                              value={this.state.cardName}
                              onChange={this.handleCardNameChange.bind(this)}
                            />
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-12">
                            <label htmlFor="cardNumber" class="form-label">
                              Card Number
                            </label>
                            <input
                              title=""
                              required
                              type="text"
                              class="form-control"
                              id="cardNumber"
                              placeholder="1234 5678 9012 3456"
                              maxlength="19"
                              value={this.state.cardNumber}
                              onChange={this.handleCardNumberChange.bind(this)}
                            />
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-6">
                            <label htmlFor="cardHolder" class="form-label">
                              First Name
                            </label>
                            <input
                              title=""
                              required
                              type="text"
                              class="form-control"
                              id="cardHolder"
                              value={this.state.firstName}
                              onChange={this.handleFirstNameChange.bind(this)}
                            />
                          </div>
                          <div class="col-md-6">
                            <label htmlFor="cardHolder" class="form-label">
                              Last Name
                            </label>
                            <input
                              title=""
                              required
                              type="text"
                              class="form-control"
                              id="cardHolder"
                              value={this.state.lastName}
                              onChange={this.handleLastNameChange.bind(this)}
                            />
                          </div>
                        </div>
                        <div class="row mt-2">
                          <div class="col-md-6">
                            <label htmlFor="expiryDate" class="form-label">
                              Expiry Date
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              id="expiryDate"
                              placeholder="MM/YYYY"
                              maxlength="7"
                              value={this.state.expiryDate}
                              onChange={this.handleExpiryDateChange.bind(this)}
                            />
                          </div>
                          <div class="col-md-6">
                            <label htmlFor="cvv" class="form-label">
                              CVV
                            </label>
                            <input
                              title=""
                              required
                              type="text"
                              autoComplete="off"
                              id="multiStepsCvv"
                              className="form-control multi-steps-cvv"
                              name="multiStepsCvv"
                              maxLength={3}
                              placeholder={654}
                              value={this.state.cvvCode}
                              onChange={this.handleCvvCodeChange.bind(this)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row d-flex align-items-center justify-content-between">
            <div className="col-sm-12 mt-4 text-center">
              <SaveButton id="saveButton" type="submit">
                Save
              </SaveButton>
              &nbsp;&nbsp;
              <CancelIconButton onClick={(e) => this.editCancel()} />
            </div>
          </div>
        </ValidatorForm>
      </>
    );
  }
}
export default withRouter(Billing);
